import apiClient from "./axios"

export const getQueueJobs = async (params = {}) => {
  const { data } = await apiClient.get("/jobs", { params })
  return data
}
